'use client';

import { cn } from '@/app/utils/cn';

export function BlogCardSkeleton({ horizontal = false, className = '' }) {
    if (horizontal) {
        return (
            <div
                className={cn(
                    'flex size-full animate-pulse flex-col gap-3 md:flex-row md:gap-6',
                    className
                )}>
                <div className="aspect-video w-full shrink-0 rounded-lg bg-gray-200 md:w-1/2 dark:bg-blue-200" />
                <div className="flex flex-1 flex-col gap-3 md:pl-3">
                    <div className="mt-6 flex flex-col gap-3">
                        <div className="flex items-center gap-2">
                            <div className="h-6 w-20 rounded-lg bg-gray-200 dark:bg-blue-200" />
                            <div className="h-5 w-24 rounded bg-gray-200 dark:bg-blue-200" />
                        </div>
                        <div className="h-8 w-3/4 rounded bg-gray-200 dark:bg-blue-200" />
                        <div className="h-4 w-full rounded bg-gray-200 dark:bg-blue-200" />
                        <div className="h-4 w-2/3 rounded bg-gray-200 dark:bg-blue-200" />
                    </div>
                    <div className="mt-auto flex items-center gap-3">
                        <div className="size-10 rounded-full bg-gray-200 dark:bg-blue-200" />
                        <div className="flex flex-col gap-1">
                            <div className="h-3 w-24 rounded bg-gray-200 dark:bg-blue-200" />
                            <div className="h-3 w-16 rounded bg-gray-200 dark:bg-blue-200" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={cn('flex size-full animate-pulse flex-col gap-3 p-4', className)}>
            <div className="aspect-video w-full rounded-lg bg-gray-200 dark:bg-blue-200" />
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                    <div className="h-6 w-20 rounded-lg bg-gray-200 dark:bg-blue-200" />
                    <div className="h-5 w-24 rounded bg-gray-200 dark:bg-blue-200" />
                </div>
                <div className="h-6 w-3/4 rounded bg-gray-200 dark:bg-blue-200" />
                <div className="h-4 w-full rounded bg-gray-200 dark:bg-blue-200" />
                <div className="h-4 w-2/3 rounded bg-gray-200 dark:bg-blue-200" />
            </div>
            <div className="mt-auto flex items-center gap-3">
                <div className="size-10 rounded-full bg-gray-200 dark:bg-blue-200" />
                <div className="flex flex-col gap-1">
                    <div className="h-3 w-24 rounded bg-gray-200 dark:bg-blue-200" />
                    <div className="h-3 w-16 rounded bg-gray-200 dark:bg-blue-200" />
                </div>
            </div>
        </div>
    );
}

export default BlogCardSkeleton;
